<template>
  <div>
    <div
      v-for="(value, norm) in norms"
      :key="`${norm}`"
      class="caption-item"
    >
      <div
        class="colored-block"
        :class="norm"
      />
      <div style="word-break: break-word;">
        <div v-if="norm === 'minimum'">
          <span>
            {{ `${$t('forms.labels.result')}
                    &lt; ${norms.minimum }
                    ${measureUnit}`
            }}
          </span>
        </div>
        <div v-if="norm === 'maximum'">
          <span>
            {{ `${norms.minimum}  &leq;
                  ${$t('forms.labels.result')}
                   &lt; ${norms.maximum}
                  ${measureUnit}`
            }}
          </span>
        </div>
        <div v-if="norm === 'lastLevel'">
          <span>
            {{ `${$t('forms.labels.result')} &geq;
                  ${norms.lastLevel}
                  ${measureUnit}`
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

export default {
    props: {
        norms: {
            type: Object,
            default: () => {},
        },
        measureUnit: {
            type: String,
            default: '',
        },
    },
    created() {
        this.norms.lastLevel = this.norms.maximum;
    },
};
</script>

<style lang="scss" scoped>
.caption-item {
  display: flex;
  align-items: center;
  padding: 1px 0;
  .colored-block {
    background: #eee;
    width: 35px;
    min-width: 35px;
    height: 35px;
    margin-right: 8px;
    &.minimum {
      background: #AD1C3F;
    }
    &.maximum {
      background: #2A7113;
    }
    &.lastLevel{
      background: #AD1C3F;
    }
  }
}
</style>
